import React, { Component } from "react";
import { Redirect } from "react-router-dom";
import { USER } from "../services/Users";
// import '../css/signin.css';
import "../assets/css/login.css";
import { connect } from "react-redux";
import Background from "../assets/img/bg/login-bg.jpg";
import {CONFIG, URLS } from "../helpers/Common";

class Login extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      email: "",
      password: "",
      isLoggedIn: false,
      showLoginMessage: false,
      loginMessage: ""
    };
  }

  componentWillMount() {}

  loginUser = async e => {
    e.preventDefault();

    let user = await USER.login({
      email: this.state.email,
      password: this.state.password
    });

    if (user.status === 200) {
      if (user.data.length > 0) {
        // this.setState({
        //     isLoggedIn:true
        // });
        console.log("user found");
      } else {
        console.log("no user found");
      }
    } else {
      console.log("some error");
    }

    console.log(user);
  };

  handleChange = e => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  render() {
    var divStyle = {
      backgroundImage: `url(${Background})`
    };
    const { isLoggedIn } = this.state;
    if (isLoggedIn === true || localStorage.getItem("user")) {
      return <Redirect to={{ pathname: URLS.profiles }} />;
    }

    return (
      <React.Fragment>
        <section className="c-login physician-login" style={divStyle}>
          <div className="bg-overlay" />
          <div className="container">
            <div className="patient-logo">
              <img src={require("../assets/img/icons/ic-login.png")} alt="" />
              <span>{CONFIG.Patient_Profile}</span>
            </div>
            <div className="login-form">
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="">{CONFIG.USERNAME}</label>
                    <input type="text" className="form-control" />
                  </div>
                </div>
                <div className="col-12">
                  <div className="form-group">
                    <label htmlFor="">{CONFIG.PASSWORD}</label>
                    <input type="password" className="form-control" />
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-12">
                  <div className="form-btn">
                    <button className="btn">{CONFIG.Submit}</button>
                  </div>
                  <a href="javascript: void(0);" className="forgot-password">
                    {CONFIG.FORGOT_PASSWORD}
                  </a>
                </div>
              </div>
            </div>
          </div>
        </section>
        {/* <form className="form-signin" onSubmit={this.loginUser}>
                <img className="mb-4" src="/docs/4.3/assets/brand/bootstrap-solid.svg" alt="" width="72" height="72" />
                <h1 className="h3 mb-3 font-weight-normal">Please sign in</h1>
                <label htmlFor="inputEmail" className="sr-only">Email address</label>
                
                <input type="email" id="inputEmail" className="form-control" placeholder="Email address" required autofocus name="email" value={this.state.email} onChange={this.handleChange} />
                <label htmlFor="inputPassword" className="sr-only">Password</label>
                <input type="password" id="inputPassword" className="form-control" placeholder="Password" required name="password" value={this.state.password} onChange={this.handleChange} />
                <div className="checkbox mb-3">
                    <label>
                    <input type="checkbox" value="remember-me" /> Remember me
                    </label>
                </div>
                <button className="btn btn-lg btn-primary btn-block" type="submit">Sign in</button>
                <p className="mt-5 mb-3 text-muted">&copy; 2017-2019</p>
            </form> */}
      </React.Fragment>
    );
  }
}

function mapStateToProps(state) {
  return {
    count: state.counter.count
  };
}
export default connect(mapStateToProps)(Login);
//export default Login;
